import { HackleUser } from "../../../../model/model"
import Workspace from "../../../../workspace/Workspace"
import EvaluateResponse from "../../../EvaluateResponse"
import Evaluation from "../../../Evaluation"
import ObjectUtil from "../../../../util/ObjectUtil"
import { EvaluatorContext } from "../../../evaluator/Evaluator"
import ExperimentEvaluation from "../../experiment/ExperimentEvaluation"
import { InAppMessageLayoutEvaluation } from "./InAppMessageLayoutEvaluation"
import { InAppMessageLayoutEvaluateRequest } from "./InAppMessageLayoutEvaluateRequest"
import { InAppMessageLayoutEvaluateResult } from "./InAppMessageLayoutEvaluateResult"

export class InAppMessageLayoutEvaluateResponse implements EvaluateResponse {
  constructor(
    readonly user: HackleUser,
    readonly workspace: Workspace,
    readonly evaluation: InAppMessageLayoutEvaluation,
    readonly references: Evaluation[],
    readonly experiment: ExperimentEvaluation | null
  ) {}

  static of(
    request: InAppMessageLayoutEvaluateRequest,
    context: EvaluatorContext,
    result: InAppMessageLayoutEvaluateResult
  ): InAppMessageLayoutEvaluateResponse {
    const experiment = experimentEvaluationOrNull(request, context)
    return new InAppMessageLayoutEvaluateResponse(
      request.user,
      request.workspace,
      new InAppMessageLayoutEvaluation(request.entity, result),
      context.references,
      experiment
    )
  }
}

function experimentEvaluationOrNull(
  request: InAppMessageLayoutEvaluateRequest,
  context: EvaluatorContext
): ExperimentEvaluation | null {
  const experimentKey = request.entity.messageContext.experimentContext?.key
  if (ObjectUtil.isNullOrUndefined(experimentKey)) {
    return null
  }
  const experiment = request.workspace.getExperimentOrNull(experimentKey)
  if (ObjectUtil.isNullOrUndefined(experiment)) {
    return null
  }
  const evaluation = context.getEvaluation(experiment)
  return evaluation instanceof ExperimentEvaluation ? evaluation : null
}
